import React, { useState } from "react";
import { Container, Row, Col, Form, Button, Alert, Spinner } from "react-bootstrap";
import axios from "axios";
import Orb from "./Orb";
import { useTranslation } from "react-i18next";

function ContactForm() {
  const { t } = useTranslation();

  const [formData, setFormData] = useState({
    type: "",
    name: "",
    email: "",
    whatsapp: "",
    city: "",
    message: "",
  });

  const [errors, setErrors] = useState({});
  const [success, setSuccess] = useState(null);
  const [alertMsg, setAlertMsg] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setErrors({ ...errors, [name]: "" });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!formData.type) newErrors.type = t("form-error-required");
    if (!formData.name) newErrors.name = t("form-error-required");
    if (!formData.email) {
      newErrors.email = t("form-error-required");
    } else if (!emailRegex.test(formData.email)) {
      newErrors.email = t("form-error-email-format");
    }
    if (!formData.whatsapp) newErrors.whatsapp = t("form-error-required");
    if (!formData.city) newErrors.city = t("form-error-required");
    if (!formData.message) newErrors.message = t("form-error-required");

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      setSuccess(false);
      setAlertMsg(t("form-alert-incomplete"));
    } else {
      try {
        setLoading(true);
        const response = await axios.post("https://childreamsstudio.com/SendEmail.php", formData, {
          headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest",
            "X-Form-Secret": "abc123supersecure", // <-- must match PHP
          },
        });

        const { status, msg } = response.data;

        if (status === 0) {
          setSuccess(true);
          setAlertMsg(t("form-alert-success"));
          setFormData({
            type: "",
            name: "",
            email: "",
            whatsapp: "",
            city: "",
            message: "",
          });
        } else {
          setSuccess(false);
          setAlertMsg(`${t("form-alert-error")}: ${msg || t("form-alert-unknown")}`);
        }
      } catch (error) {
        setSuccess(false);
        setAlertMsg(t("form-alert-fail"));
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <Container>
      <Orb color="rgb(167, 209, 105)" bottom="0vh" left="0vh" />

      <div className="text-center mb-4">
        <h3 className="section-title color-purple">{t("contact-form-title")}</h3>
        <p className="mx-auto" style={{ maxWidth: "800px" }}>
          {t("contact-form-desc")}
        </p>
      </div>

      <Form id="contact-form" onSubmit={handleSubmit}>
        <Form.Group className="mb-3">
          <Form.Select name="type" value={formData.type} onChange={handleChange} isInvalid={!!errors.type} className="form-select rounded-pill-input" aria-label={t("form-cooperation-type")}>
            <option value="">{t("form-cooperation-type")}</option>
            <option value={t("form-cooperation-type-1")}>{t("form-cooperation-type-1")}</option>
            <option value={t("form-cooperation-type-2")}>{t("form-cooperation-type-2")}</option>
            <option value={t("form-cooperation-type-3")}>{t("form-cooperation-type-3")}</option>
            <option value={t("form-cooperation-type-4")}>{t("form-cooperation-type-4")}</option>
            <option value={t("form-cooperation-type-5")}>{t("form-cooperation-type-5")}</option>
            <option value={t("form-cooperation-type-6")}>{t("form-cooperation-type-6")}</option>
          </Form.Select>
          {errors.type && <Form.Text className="text-danger">{errors.type}</Form.Text>}
        </Form.Group>

        <Row className="mb-3">
          <Col>
            <Form.Control type="text" name="name" value={formData.name} onChange={handleChange} isInvalid={!!errors.name} placeholder={t("form-name")} className="rounded-pill-input" />
            {errors.name && <Form.Text className="text-danger">{errors.name}</Form.Text>}
          </Col>
          <Col>
            <Form.Control type="email" name="email" value={formData.email} onChange={handleChange} isInvalid={!!errors.email} placeholder={t("form-email")} className="rounded-pill-input" />
            {errors.email && <Form.Text className="text-danger">{errors.email}</Form.Text>}
          </Col>
        </Row>

        <Row className="mb-3">
          <Col>
            <Form.Control type="text" name="whatsapp" value={formData.whatsapp} onChange={handleChange} isInvalid={!!errors.whatsapp} placeholder={t("form-whatsapp")} className="rounded-pill-input" />
            {errors.whatsapp && <Form.Text className="text-danger">{errors.whatsapp}</Form.Text>}
          </Col>
          <Col>
            <Form.Control type="text" name="city" value={formData.city} onChange={handleChange} isInvalid={!!errors.city} placeholder={t("form-city")} className="rounded-pill-input" />
            {errors.city && <Form.Text className="text-danger">{errors.city}</Form.Text>}
          </Col>
        </Row>

        <Form.Group className="mb-3">
          <Form.Control as="textarea" rows={4} name="message" value={formData.message} onChange={handleChange} isInvalid={!!errors.message} placeholder={t("form-message")} className="rounded-pill-input" />
          {errors.message && <Form.Text className="text-danger">{errors.message}</Form.Text>}
        </Form.Group>

        <div className="text-end">
          <Button variant="warning" type="submit" className="btn-eclipse" disabled={loading}>
            {loading ? (
              <>
                <Spinner animation="border" size="sm" role="status" className="me-2" />
                {t("form-sending")}
              </>
            ) : (
              t("form-send")
            )}
          </Button>
        </div>
      </Form>

      {success !== null && (
        <Alert variant={success ? "success" : "danger"} className="text-center">
          {alertMsg}
        </Alert>
      )}
    </Container>
  );
}

export default ContactForm;
